import * as React from 'react';

import { DistanceSettings } from './distance';
import { TimeSettings } from './time';
import { AccessPointSettings } from './accessPoint';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  onDataChanged: (data: WorldSettings) => void,
  submitInProgress: boolean,
  dataTimestamp: number
}

export function LocationSettings(props: IProps) {

  return (<div className="threshold-settings-composition location">
    <TimeSettings
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
    <DistanceSettings
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
    <AccessPointSettings
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
  </div>);
}
